import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { toast } from 'react-toastify';

const SocDrawLotteryList = () => {
    const navigate = useNavigate();
    const [lotteryDates, setLotteryDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [lotteryResults, setLotteryResults] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch available lottery dates
    useEffect(() => {
        const datesRef = ref(db, 'ekamwatapzp/LotteryDates');
        onValue(datesRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const dates = Object.keys(data).map(key => data[key].date);
                // Filter unique and sort
                const uniqueDates = [...new Set(dates)].sort((a, b) => new Date(b) - new Date(a));
                setLotteryDates(uniqueDates);
                if (uniqueDates.length > 0) setSelectedDate(uniqueDates[0]);
            }
        });
    }, []);

    const fetchResults = () => {
        if (!selectedDate) {
            toast.error("कृपया तारीख निवडा.");
            return;
        }

        setLoading(true);
        // Fetching results for Societies
        const resultsRef = ref(db, 'ekamwatapzp/LotteryResults/Society');
        onValue(resultsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const filtered = Object.keys(data)
                    .map(key => ({ id: key, ...data[key] }))
                    .filter(item => item.lotteryDate === selectedDate);

                setLotteryResults(filtered);
            } else {
                setLotteryResults([]);
            }
            setLoading(false);
        });
    };

    // Auto fetch on initial date set
    useEffect(() => {
        if (selectedDate) fetchResults();
    }, [selectedDate]);

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-gray-50 flex flex-col ">
                {/* Header Section */}
                <div className="px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-gray-200">
                    <h1 className="text-xl font-bold text-[#344767] tracking-tight">मजूर संस्था लॉटरी यादी</h1>
                    <div className="flex items-center text-sm font-medium text-gray-500 gap-2">
                        <span>सांगली जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-600 font-semibold">मजूर संस्था लॉटरी यादी</span>
                    </div>
                </div>

                <div className="p-6">
                    <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-[#344767]">

                        {/* Filter Section */}
                        <div className="mb-8 p-6 bg-white border-b border-gray-100 flex flex-col gap-3">
                            <label className="text-sm font-bold text-gray-700">
                                लॉटरीची तारीख निवडा <span className="text-red-500">*</span>
                            </label>
                            <div className="flex items-center gap-4">
                                <select
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    className="w-full md:w-64 border border-gray-300 rounded px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500"
                                >
                                    <option value="">Select Date</option>
                                    {lotteryDates.map((date, idx) => (
                                        <option key={idx} value={date}>{date}</option>
                                    ))}
                                </select>
                                <button
                                    onClick={fetchResults}
                                    className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded text-sm font-semibold transition shadow-md"
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto border border-gray-200 rounded">
                            <table className="w-full text-left text-sm border-collapse">
                                <thead>
                                    <tr className="bg-white text-gray-700 font-bold border-b border-gray-200">
                                        <th className="px-6 py-4 border-r border-gray-200 w-16 text-center">#</th>
                                        <th className="px-6 py-4 border-r border-gray-200 min-w-[250px]">संस्थेचे नाव</th>
                                        <th className="px-6 py-4 border-r border-gray-200">फोन नंबर</th>
                                        <th className="px-6 py-4 border-r border-gray-200">तालुका</th>
                                        <th className="px-6 py-4 min-w-[350px]">कामाचे नाव</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {loading ? (
                                        <tr><td colSpan="5" className="text-center py-10 text-gray-400">Loading Results...</td></tr>
                                    ) : lotteryResults.length > 0 ? (
                                        lotteryResults.map((item, index) => (
                                            <tr key={item.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-indigo-50/30 transition-colors`}>
                                                <td className="px-6 py-4 border-r border-gray-200 text-center font-medium">{index + 1}</td>
                                                <td className="px-6 py-4 border-r border-gray-200 font-medium text-gray-800">
                                                    {item.societyName || item.applicantName || 'N/A'}
                                                </td>
                                                <td className="px-6 py-4 border-r border-gray-200 text-gray-600">
                                                    {item.winnerPhone || item.whatsappNo || 'N/A'}
                                                </td>
                                                <td className="px-6 py-4 border-r border-gray-200 text-gray-700">
                                                    {item.taluka || item.winnerTaluka || 'N/A'}
                                                </td>
                                                <td className="px-6 py-4">
                                                    <div className="flex flex-col gap-1">
                                                        <span className="text-gray-800 leading-relaxed font-medium">
                                                            {item.workName || 'Work Name Not Found'}
                                                        </span>
                                                        <span className="text-gray-500 font-bold text-xs">
                                                            Rs. - {item.amount || '0.00'}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="px-6 py-12 text-center text-gray-500 font-medium">
                                                No data available in table
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default SocDrawLotteryList;
